export const FETCH_FLOOR_PLAN_LIST_IDENTIFIER =
  "view-position-modal-content-fetch-floor-plan-list";
